/**
 * Builds a query string from status filter array
 *
 * DynamoDB Limitation: Cannot use OR logic or parentheses in queries.
 * Multi-select filters are not supported - only the first selected status is used.
 *
 * @param statuses - Array of status filter strings (e.g., ['status:JR', 'status:JP'])
 * @returns Query string for single status filter (no OR logic, no parentheses)
 *
 * @example
 * buildStatusQuery([]) → '#job'
 * buildStatusQuery(['status:JR']) → 'status:JR'
 * buildStatusQuery(['status:JR', 'status:JP']) → 'status:JR' (only first)
 * buildStatusQuery(['status:JR', 'invalid:value', 'status:JP']) → 'status:JR'
 */
export function buildStatusQuery(statuses: string[]): string {
  // Filter out invalid values (must start with 'status:')
  const validStatuses = statuses.filter(status => status.startsWith('status:'));

  // Empty array or no valid statuses → default to all jobs
  if (!validStatuses || validStatuses.length === 0) {
    return '#job';
  }

  // DynamoDB limitation: Only single status filter supported
  // Return first status only (no OR logic, no parentheses)
  return validStatuses[0];
}
